
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import DrugOPDHomeOrderSerializer from '../types/DrugOPDHomeOrderSerializer_apps_TPD'


const HOST = `${config.API_HOST}`
/* ['BaseDrugOrderView'] */
/* params:  */
/* data:  */
const DrugOPDHomeOrderView : 
{
  get: ({pk, params, apiToken, extra}:
             {  pk: any,
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  post:   ({params, data, apiToken, extra}:
            {
            params?: any,
            data?: any,
            apiToken?: any,
            extra?: any
        }) => any,
  put:   ({pk, params, data, apiToken, extra}:
             { pk: any, 
                params?: any,
                data?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  patch:    ({pk, params, data, apiToken, extra}:
             { pk: any, 
                params?: any,
                data?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  get: async ({pk, params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken) {
        base.client.defaults.headers.common["Authorization"] = "Token " + apiToken
    }
    if (extra?.division) {
      base.client.defaults.headers.common["division"] = extra.division;
    }
    const result = await to(base.client.get(`${HOST}/apis/TPD/drug-opd-home-order/${pk}/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  post: async ({params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken) {
        base.client.defaults.headers.common["Authorization"] = "Token " + apiToken
    }
    if (extra?.division) {
      base.client.defaults.headers.common["division"] = extra.division;
    }
    const result = await to(base.client.post(`${HOST}/apis/TPD/drug-opd-home-order/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  put: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken) {
        base.client.defaults.headers.common["Authorization"] = "Token " + apiToken
    }
    if (extra?.division) {
      base.client.defaults.headers.common["division"] = extra.division;
    }
    const result = await to(base.client.put(`${HOST}/apis/TPD/drug-opd-home-order/${pk}/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  patch: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken) {
        base.client.defaults.headers.common["Authorization"] = "Token " + apiToken
    }
    if (extra?.division) {
      base.client.defaults.headers.common["division"] = extra.division;
    }
    const result = await to(base.client.patch(`${HOST}/apis/TPD/drug-opd-home-order/${pk}/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default DrugOPDHomeOrderView

